import type {
  ColorPalette,
  CustomColorPalette,
} from '../../core/types/color-palette.js';
import { getColorPalette } from '../../core/utils/get-color-palette.js';
import { DEFAULT_GANTT_COLORS } from '../constants/defaults.js';
import type { GanttSegmentData } from '../types/gantt-chart.js';

export const getEntryColor = (
  entry: GanttSegmentData,
  colorAccessor?: string,
  colorPalette?: ColorPalette | CustomColorPalette,
): string => {
  colorAccessor = colorAccessor || 'color';

  const color =
    typeof entry[colorAccessor] === 'string'
      ? (entry[colorAccessor] as string)
      : '';
  if (colorPalette) {
    return getColorPalette(color, 0, colorPalette).Default;
  }

  return color || DEFAULT_GANTT_COLORS.default;
};
